/**
 * v1 `TISB Stream/<UAS_ID>` adapter (backfill).
 *
 * Payload shape (verified on staging 2026-05-15):
 *   { uas_id, callsign, last_update, last_update_unix, cifib_status }
 *
 * cifib_status is the connection state to the TIS-B service:
 *   'connected'    → 'Active'
 *   'disconnected' → 'N/A'
 *
 * This populates `c2.ec.tisb.status` — the one field we can fill in the
 * Electronic Conspicuity tile group without a full c2links envelope.
 */
import { z } from 'zod';

export const V1TisbStreamPayload = z.object({
  uas_id: z.string(),
  callsign: z.string().nullish(),
  cifib_status: z.string().nullish(),
  last_update: z.string().nullish(),
  last_update_unix: z.number().nullish(),
});
export type V1TisbStreamPayload = z.infer<typeof V1TisbStreamPayload>;

export interface TisbStreamUpdate {
  drone_id: string;
  tisb_status: 'Active' | 'N/A';
  last_update_at: string | null;
}

export function tisbStreamToUpdate(raw: unknown): TisbStreamUpdate | null {
  const parsed = V1TisbStreamPayload.safeParse(raw);
  if (!parsed.success) return null;
  const v = parsed.data;
  const connected = (v.cifib_status ?? '').toLowerCase() === 'connected';
  return {
    drone_id: v.uas_id,
    tisb_status: connected ? 'Active' : 'N/A',
    last_update_at: v.last_update ?? null,
  };
}
